<template>
  <v-header />
  <v-sidebar />
  <!-- <div class="main-content">
    <v-sidebar />
    <div class="container">
      <router-view />
    </div>
  </div> -->
  <div class="page-content-box" :class="{ 'content-collapse': sidebar.collapse }">
		<div class="content">
			<router-view />
		</div>
	</div>
  
</template>

<script setup>
	import vHeader from "../../components/header.vue";
	import vSidebar from "../../components/sidebar.vue";

  import { useSidebarStore } from "../../stores/sidebar";

	const sidebar = useSidebarStore();
</script>

<style lang="scss" scoped>
// .main-content{
  // display: flex;
  // justify-content: space-between;
  .container {
    // @include background_color("background_home");
    padding: 40px 20px;
    // flex: 1;
  }
// }
.page-content-box {
		position: absolute;
		left: 245px;
		right: 0;
		top: 70px;
		bottom: 0;
		padding-bottom: 30px;
		-webkit-transition: left 0.6s ease-in-out;
		transition: left 0.6s ease-in-out;
		min-width: 1200px;

		> .content {
			height: 100%;
			padding: 10px;
			overflow: auto;
			box-sizing: border-box;
			font-size: 14px;
		}
	}

	.content-collapse {
		left: 0px;
    transition: all 0.4s;
	}

</style>
